import { KeyServerWretch } from '../api';

/**
 * @deprecated
 * @name KeyServer.signup
 * @param {object} formData
 * @param {string} formData.username
 * @param {string} formData.email
 * @param {string} formData.password
 * @param {string} formData.guid
 * @param {string} formData.keyfile
 * @param {string} formData.internalip
 * @param {string} formData.servername
 * @param {string} formData.newsletter
 * @param {string} formData.comments - honeypot
 * @returns {Promise<object>} data response body
 */
export const signup = formData => KeyServerWretch
  .url('/ips/newaccount')
  .formUrl(formData)
  .post();

/**
 * @deprecated
 * @name KeyServer.login
 * @param {string} url - '/ips/login' | '/account/license/recover' | '/account/license/replace';
 * @param {object} formData
 * @param {string} formData.email
 * @param {string} formData.password
 * @param {string} formData.guid
 * @param {string} formData.keyfile
 * @param {string} formData.internalip
 * @param {string} formData.servername
 * @param {string} formData.comments - honeypot
 * @returns {Promise<object>} data response body
 */
export const login = (url, formData) => KeyServerWretch
  .url(url)
  .formUrl(formData)
  .post();

/**
 * @deprecated
 * @name KeyServer.validate
 * @param {object} formData
 * @param {string} formData.apikey (provided from the Sign Up or Sign In response)
 * @param {string} formData.code
 * @returns {Promise<object>} data response body
 */
export const validate = formData => KeyServerWretch
  .url('/ips/validate')
  .formUrl(formData)
  .post();

/**
 * @name KeyServer.troubleshoot
 * @param {object} formData
 * @param {string} formData.email required
 * @param {string} formData.subject required
 * @param {string} formData.message required
 * @param {string} formData.guid optional – if passed it'll be appended to the email subject instead of date/time
 * @param {string} formData.comments HONEYPOT FIELD. Passing a non-empty value for 'comments' will trigger the honeypot, thus not send an email but won't return any errors.
 * @returns {Promise<object>} data response body
 */
export const troubleshoot = formData => KeyServerWretch
  .url('/ips/troubleshoot')
  .formUrl(formData)
  .post();

/**
 * @deprecated
 * @name KeyServer.signOut
 * @param {object} formData
 * @param {string} formData.keyfile
 * @returns {Promise<object>} data response body
 *
 * @NOTE endpoint must stay as ending with unregister even though we changed terminology to sign out
 */
export const signOut = formData => KeyServerWretch
  .url('/account/server/unregister')
  .formUrl(formData)
  .post();

/**
 * @name KeyServer.startTrial
 * @param {object} formData
 * @param {string} formData.guid
 * @returns {Promise<object>} data response body
 */
export const startTrial = formData => KeyServerWretch
  .url('/account/trial')
  .formUrl(formData)
  .post();

/**
 * @deprecated
 * @name KeyServer.update
 * @param {object} formData
 * @param {string} formData.username
 * @param {string} formData.email
 * @param {string} formData.password
 * @param {string} formData.guid
 * @param {string} formData.comments - honeypot
 * @returns {Promise<object>} data response body
 */
export const update = formData => KeyServerWretch
  .url('/ips/updateaccount')
  .formUrl(formData)
  .post();

/**
 * @deprecated
 * @name KeyServer.replaceKey
 * @param {object} formData
 * @param {string} formData.guid (should be the new GUID)
 * @param {string} formData.keyfile
 * @param {string} formData.email (key server will send new key to this email)
 * @returns {Promise<object>} data response body
 * Success response – Success page will send key down for install
 * HTTP 200 - JSON response:
 * {
 *   "newkey": "base64(new keyfile contents)"
 * }
 * Failure response
 * HTTP 400/403/406 - JSON response:
 * {
 *   "error": "reason why operation failed"
 * }
 */
export const replaceKey = formData => KeyServerWretch
  .url('/account/license/transfer')
  .formUrl(formData)
  .post();
